export default (function (w, d) {
    'use strict';

    function ExampleController() {
        this.setup();
    }

    ExampleController.prototype.setup = function () {
        console.log('Hey, I am an ExampleController!');
    }

    return ExampleController;
}(window, document));

